export const UPDATE_FETCH_MODE = 'UPDATE_FETCH_MODE';
export const updateFetchMode = (payload) => ({
    type: UPDATE_FETCH_MODE,
    payload,
});
//# sourceMappingURL=meta-state-actions.js.map